(() => {
  const panel = document.querySelector('.np-filter-panel');
  if (!panel) return;
  const mobile = window.matchMedia('(max-width: 1024px)');
  const opener = document.querySelector('.np-filter-open');
  const closer = panel.querySelector('.np-filter-close');
  const results = panel.querySelector('.np-show-results');
  const status = document.querySelector('.np-filter-announcement');
  let overlay;
  let previousFocus;
  let scrollY = 0;
  let savedBodyStyle;
  let selectedLabel;
  let busy = false;
  const setBusy = value => {
    busy = value;
    panel.setAttribute('aria-busy', String(value));
    document.querySelector('.tt-product-listing')?.setAttribute('aria-busy', String(value));
    results.disabled = value;
    results.classList.toggle('np-is-loading', value);
    if (value && status) status.textContent = panel.dataset.loading;
  };
  const close = (restore = true) => {
    if (!panel.classList.contains('column-open')) return;
    panel.classList.remove('column-open');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    opener?.setAttribute('aria-expanded', 'false');
    overlay?.remove();
    document.body.classList.remove('np-filters-open');
    Object.assign(document.body.style, savedBodyStyle);
    window.scrollTo(0, scrollY);
    if (restore) previousFocus?.focus();
  };
  opener?.addEventListener('click', () => {
    if (!mobile.matches) return;
    previousFocus = document.activeElement;
    scrollY = window.scrollY;
    savedBodyStyle = {position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow};
    Object.assign(document.body.style, {position: 'fixed', top: `${-scrollY}px`, width: '100%', overflow: 'hidden'});
    document.body.classList.add('np-filters-open');
    panel.classList.add('column-open');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    opener.setAttribute('aria-expanded', 'true');
    overlay = document.createElement('div');
    overlay.className = 'np-filter-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', () => close());
    document.body.append(overlay);
    closer.focus();
  });
  closer.addEventListener('click', () => close());
  results.addEventListener('click', () => close());
  document.addEventListener('keydown', event => {
    const checkbox = event.target.closest('.np-filter-choice[role="checkbox"]');
    const heading = event.target.closest('.np-filter-panel .tt-collapse-title');
    if (event.key === ' ' && checkbox) {event.preventDefault(); checkbox.click();}
    if ((event.key === ' ' || event.key === 'Enter') && heading) {event.preventDefault(); heading.click();}
    if (!panel.classList.contains('column-open')) return;
    if (event.key === 'Escape') {event.preventDefault(); close();}
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary')].filter(element => element.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
  });
  mobile.addEventListener('change', () => {if (!mobile.matches) close(false);});
  document.addEventListener('click', event => {
    const heading = event.target.closest('.np-filter-panel .tt-collapse-title');
    if (heading) setTimeout(() => heading.setAttribute('aria-expanded', String(heading.parentElement.classList.contains('open'))), 0);
    const link = event.target.closest('.shopifyfiltres-js a, .filtres-remove-js a, .filtres-js a');
    if (!link) return;
    if (busy) {event.preventDefault(); event.stopImmediatePropagation(); return;}
    selectedLabel = panel.contains(link) ? link.getAttribute('data-np-label') : null;
  }, true);
  document.addEventListener('np:filters-loading', () => setBusy(true));
  document.addEventListener('np:filters-updated', () => {
    setBusy(false);
    if (status) status.textContent = document.querySelector('.np-results-total')?.textContent || '';
    if (selectedLabel && panel.classList.contains('column-open')) {
      [...panel.querySelectorAll('[data-np-label]')].find(link => link.dataset.npLabel === selectedLabel)?.focus();
    }
    selectedLabel = null;
  });
  document.addEventListener('np:filters-error', () => {
    setBusy(false);
    if (status) status.textContent = panel.dataset.error;
  });
  document.querySelector('.np-sort-select')?.addEventListener('change', event => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
})();
